<div class="root-container">
	<div class="renew-password-box">
		<div *ngIf="(renewPasswordTokenExpired$ | async) === false && (renewPasswordLoading$ | async) === false && (renewPasswordSuccess$ | async ) === false && (renewPasswordToken$ | async)">
			<div class="renew-password-header">
				<div class="logo">
					<i class="icon-smash_icologo_chip"></i>
				</div>
				<h1 class="title" translate>FORGOT_PASSWORD_RENEW_TITLE</h1>
			</div>
			<form [formGroup]="renewPasswordForm" class="renew-password-form" (ngSubmit)="onSubmit()">
				<div class="renew-password-instructions">
					<p>
						{{ 'FORGOT_PASSWORD_RENEW_TEXT' | translate }}
					</p>
				</div>
				<div class="renew-password-important-information">
					<div>{{(renewPasswordToken$ | async).email}}</div>
				</div>
				<div class="input-container">
					<app-smash-input type="password" placeholder="{{ 'FORGOT_PASSWORD_RENEW_PLACEHOLDER_USERNAME' | translate }}"
						formControlName="password" [error]="submitted && (f.password.invalid || (renewPasswordError$ | async))">
						<div *ngIf="submitted && (renewPasswordError$ | async)" error translate>SIGNIN_ALERT_MESSAGE_INVALID_PASSWORD</div>
						<div *ngIf="submitted && f.password.invalid" error translate>UPLOADER_CONFIG_SMASH_SUBTITLE_PASSWORD_ERROR</div>
					</app-smash-input>
				</div>
				<div class="renew-password-form-footer">					
					<button class="btn larger red" type="submit" translate>FORGOT_PASSWORD_RENEW_BUTTON_LABEL_SEND</button>
				</div>
			</form>
		</div>
		<!-- loading -->
		<div *ngIf="(renewPasswordLoading$ | async) === true " class="spinner-container">
			<div class="loading-spinner-container">
                <div class="loading-spinner-grey"></div>
            </div>
		</div>
		<!-- confirmation message -->
		<div *ngIf="(renewPasswordLoading$ | async) === false && (renewPasswordSuccess$ | async) === true ">
			<div class="renew-password-header">
				<div class="logo">
					<i class="icon-smash_icologo_chip"></i>
				</div>
				<h1 class="title" translate>FORGOT_PASSWORD_RENEW_SUCCESS_TITLE</h1>
			</div>
			<div class="renew-password-body">
				{{ 'FORGOT_PASSWORD_RENEW_SUCCESS_DESCRIPTION' | translate }}
			</div>	
			<div class="renew-password-form-footer">
				<div></div>
				<button type="button" class="btn mlarge red" [routerLink]="['/signin']"
					translate>FORGOT_PASSWORD_RENEW_SUCCESS_BUTTON_LABEL_LOGIN</button>
			</div>		
		</div>

		<!-- error token expired -->
		<div *ngIf="(renewPasswordTokenExpired$ | async) === true">			
			<div class="renew-password-header">
				<div class="logo">
					<i class="icon-smash_icologo_chip"></i>
				</div>
				<h1 class="title">{{'FORGOT_PASSWORD_RENEW_TOKEN_EXPIRED_TITLE' | translate}}</h1>
			</div>
			<div class="renew-password-body">
				{{ 'FORGOT_PASSWORD_RENEW_TOKEN_EXPIRED_BODY' | translate}}
			</div>
			<div class="renew-password-form-footer">					
				<button (click)="redirectToForgotPassword()" class="btn larger red" type="button">{{'FORGOT_PASSWORD_RENEW_BUTTON_LABEL_RETURN_TO_LOGIN' | translate}}</button>
			</div>
		</div>

		<!-- error renew password invalid  -->
		 <div *ngIf="(renewPasswordTokenInvalid$ | async)">
			<div class="renew-password-header">
				<div class="logo">
					<i class="icon-smash_icologo_chip"></i>
				</div>
				<h1 class="title">{{'FORGOT_PASSWORD_RENEW_TOKEN_INVALID_TITLE' | translate}}</h1>
			</div>
			<div class="renew-password-body">
				{{ 'FORGOT_PASSWORD_RENEW_TOKEN_INVALID_BODY' | translate}}
			</div>
			<div class="renew-password-form-footer">					
				<button (click)="redirectToForgotPassword()" class="btn larger red" type="button">{{'FORGOT_PASSWORD_RENEW_BUTTON_LABEL_RETURN_TO_LOGIN' | translate}}</button>
			</div>
		 </div>
	</div>
</div>